// Curated model list — real IDs from live API queries
// vision: true = can accept images as input
// imageGen: true = can generate images (used for image model picker)

export const CHAT_MODELS = [
  // Anthropic
  { id: 'anthropic/claude-sonnet-4-6', name: 'Claude Sonnet 4.6', provider: 'Anthropic', vision: true, default: true },
  { id: 'anthropic/claude-sonnet-5',   name: 'Claude Sonnet 5',   provider: 'Anthropic', vision: true },
  { id: 'anthropic/claude-sonnet-5-5', name: 'Claude Sonnet 5.5', provider: 'Anthropic', vision: true },
  { id: 'anthropic/claude-opus-5',     name: 'Claude Opus 5',     provider: 'Anthropic', vision: true },
  { id: 'anthropic/claude-haiku-4-5-20251001', name: 'Claude Haiku 4.5', provider: 'Anthropic', vision: true },
  { id: 'anthropic/claude-opus-4-8',   name: 'Claude Opus 4.8',   provider: 'Anthropic', vision: true },
  // OpenAI
  { id: 'openai/gpt-6.1-sol',          name: 'GPT-6.1 Sol',       provider: 'OpenAI',    vision: true },
  { id: 'openai/gpt-6-astra',          name: 'GPT-6 Astra',       provider: 'OpenAI',    vision: true },
  { id: 'openai/gpt-6-sol',            name: 'GPT-6 Sol',         provider: 'OpenAI',    vision: true },
  { id: 'openai/gpt-6-luna',           name: 'GPT-6 Luna',        provider: 'OpenAI',    vision: true },
  // Google
  { id: 'google/gemini-3.8-flash',     name: 'Gemini 3.8 Flash',  provider: 'Google',    vision: true },
];

export const IMAGE_MODELS = [
  { id: 'google/gemini-3.8-flash',     name: 'Gemini 3.8 Flash',  provider: 'Google',    default: true },
  { id: 'openai/gpt-image-2',          name: 'GPT Image 2',       provider: 'OpenAI' },
];

export const PROVIDER_COLORS = {
  Anthropic: '#d97706',
  OpenAI:    '#10b981',
  Google:    '#6366f1',
};

export function getModel(id) {
  return CHAT_MODELS.find(m => m.id === id) || IMAGE_MODELS.find(m => m.id === id);
}
